<template>
  <div class="company-info">
    <InsuranceCompanyLogo
      class="company-info__logo"
      :logo="companyLogo"
      :alternative-text="companyName"
    />
    <h4 class="company-info__name">{{ companyName }}</h4>
    <Rating
      class="company-info__rating"
      :rating="companyRating"
    />
    <SmartLink
      v-if="hasCompanyBranches"
      class="company-info__branches"
      :method="() => $emit('show-company-locations')"
    >
      Показати відділення
    </SmartLink>
  </div>
</template>

<script>
import { InsuranceCompanyLogo } from '@/shared/ui/insurance';
import { SmartLink } from '@/shared/ui/link';
import { Rating } from '@/shared/ui/rating';

export default {
  props: {
    companyLogo: {
      type: String,
      default: '',
    },
    companyName: {
      type: String,
      required: true,
    },
    companyRating: {
      type: [Number, null],
      default: null,
    },
    hasCompanyBranches: {
      type: Boolean,
      default: false,
    },
  },
  components: { Rating, SmartLink, InsuranceCompanyLogo },
};
</script>

<style scoped lang="scss">
.company-info {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 190px;
  padding: 16px 20px;

  @media (max-width: 500px) {
    padding: 2px 20px;
  }

  &__logo {
    display: flex;
    justify-content: center;
    width: 150px;
    margin-bottom: 8px;
  }

  &__name {
    font-size: 14px;
    font-weight: 400;
    text-align: center;
    margin-bottom: 8px;
  }

  &__rating {
    margin-bottom: 20px;
  }

  &__branches {
    font-size: 12px;
    font-weight: 400;
  }
}

::v-deep .company-logo, ::v-deep .company-logo__placeholder, ::v-deep .company-logo__img {
  max-height: 150px !important;
  max-width: 150px !important;
  margin-right: 0 !important;
}
</style>
